import { configureStore } from '@reduxjs/toolkit';
import { journeySlice } from './slices/JourneySlice';
import { userSlice } from './slices/UserSlice';

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    journey: journeySlice.reducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store;
